// JavaScript Document


function initFloatingBlock() {

    gsap.utils.toArray(".floating-block").forEach((block, i) => {

        const style = window.getComputedStyle(block)
        const matrix = style.transform || style.webkitTransform || style.mozTransform;
        const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')


        function setParallaxEffect() {
             gsap.fromTo(block,{
                y: matrixValues[5] - 100,

                  // rotationZ: 6,
              }, {
                scrollTrigger: {
                     start: "top bottom",
                  trigger: block,
                  scrub: true,

                },
                y: matrixValues[5],
                // scale:1,
                  // rotationZ: 0,
                ease: "none"
              });

        }

       // setParallaxEffect();

    });



}
